import { Formik } from 'formik';
import { observer } from 'mobx-react';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { SaveButton } from 'src/libs/ui-kit/buttons/SaveButton';
import { useStore } from 'src/modules/users/hooks/useStore';
import { UserAddressesStoreContext } from '../../UserAddresses.widget';
import { UserAddressEditForm } from '../forms/UserAddressEditForm';

export const UserAddressCreateModal = observer(() => {
  const store = useStore(UserAddressesStoreContext);

  return (
    <Formik initialValues={{}} onSubmit={store.createAddress} enableReinitialize>
      <Modal className="modal-slide" show={store.createAddressModal.isVisible} onHide={store.createAddressModal.hide}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Создать адрес</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserAddressEditForm />
        </Modal.Body>
        <Modal.Footer>
          <SaveButton>Сохранить</SaveButton>
          <Button variant="light" onClick={store.createAddressModal.hide}>
            Отменить
          </Button>
        </Modal.Footer>
      </Modal>
    </Formik>
  );
});
